{
    "LicenseManagement_Title": "Licentiebeheer voor bedrijven",
    "LicenseManagement_Heading_License": "Licentie - Teams",
    "LicenseManagement_Heading_Quantity": "Hoeveelheid",
    "LicenseManagement_Essentials": "Benodigdheden",
    "LicenseManagement_Essentials_MST": "CXA-standaard",
    "LicenseManagement_Professional": "Professioneel",
    "LicenseManagement_Professional_MST": "CXA Premium",
    "LicenseManagement_Enterprise": "Onderneming",
    "LicenseManagement_Enterprise_MST": "CXA Geavanceerd (Historisch)",
    "LicenseManagement_CallCentreAgent": "Callcenter Agent",
    "LicenseManagement_CallCentreAgent_MST": "CXA Premium",
    "LicenseManagement_CallCentreSupervisor": "Supervisor callcenter",
    "LicenseManagement_CallCentreSupervisor_MST": "CXA Geavanceerd",
    "LicenseManagement_Validation_Number": "Moet een geldig nummer zijn",
    "LicenseManagement_Validation_Limit": "Overschrijdt CME Licentie Cap. Moet minder zijn dan of gelijk aan {}",
    "LicenseManagement_Validation_Limit_Reached": "Overschrijdt CME-licentieplafond. Geen licenties meer beschikbaar",
    "LicenseManagement_Validation_MAX_LIMIT": "Aantal overschrijdt maximaal toegestaan aantal",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "Getal moet positief zijn",
    "NAME": "LicenseManagement",
    "LicenseManagement_CXIntegration": "CX-integratie",
    "LicenseManagement_Essentials_WBX": "WxC-gebruiker",
    "LicenseManagement_Essentials_MSTB": "Historische gebruiker",
    "LicenseManagement_Professional_WBX": "Professioneel",
    "LicenseManagement_Professional_MSTB": "Realtime gebruiker",
    "LicenseManagement_Enterprise_WBX": "Onderneming",
    "LicenseManagement_Enterprise_MSTB": "Onderneming",
    "LicenseManagement_CallCentreAgent_WBX": "WxC Agent",
    "LicenseManagement_CallCentreAgent_MSTB": "Tussenpersoon",
    "LicenseManagement_CallCentreSupervisor_WBX": "WxC-supervisor",
    "LicenseManagement_CallCentreSupervisor_MSTB": "Manager"
}